export const datas = [
  {
    name: "products",
    items: [
      { value: "Invoices" },
      { value: "Payment Links" },
      { value: "QR Code Payments" },
      { value: "Payouts" },
      { value: "Subscriptions" },
      { value: "Point of Sale" },
    ],
  },
  {
    name: "company",
    items: [
      { value: "Careers" },
      { value: "Team" },
      { value: "Support" },
      { value: "Blog" },
      { value: "Pricing" },
      // { value: "Terms" },
      // { value: "Privacy Policy" },
      // { value: "Merchant Policy" },
    ],
  },
  {
    name: "legal",
    items: [
      { value: "Terms" },
      { value: "Privacy Policy" },
      { value: "Merchant Policy" },
    ],
  },
  {
    name: "resources",
    items: [
      { value: "Affiliates" },
      { value: "Updates" },
      { value: "Status page" },
      { value: "Developers" },
      { value: "API Documentation" },
    ],
  },
  {
    name: "projects",
    items: [{ value: "aircat" }],
  },
  {
    name: "contact us",
    items: [{ value: "support@lipana.app" }, { value: "+254791814113" }],
    location: "1st Floor,  Trio Complex behind Garden City, Thika Road",
  },
];
